<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-magnify</v-icon>
        <v-toolbar-title>Transaction Type Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="doSelect">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-flex xs12>
          <v-card>
            <v-card-text>
              <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
              <v-data-table
              :headers="headers"
              :items="items"
              :loading="loading"
              :custom-filter="customSearch"
              :no-data-text="noDataText"
              :options.sync="pagination"
              item-key="key"
              show-select
              v-bind:search="search"
              v-model="selected"
              @input="enterSelect"
              @toggle-select-all="enterSelectAll(pagination, items, selected)"
              >
              </v-data-table>
              <div v-if="checkedItems.length === 0" class="small font-weight-light grey--text">Note: Default is "All" if no item is selected. </div>
              <v-textarea v-if="checkedItems.length > 0" label="Selected Items" v-model="checkedItems" rows="1" readonly></v-textarea>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green" dark class="mb-2" @click="doSelect('All', 'tranType')">
                Select All
                <v-icon right>mdi-check-all</v-icon>
              </v-btn>
              <v-btn color="info" dark class="mb-2" @click.prevent="doReset">
                Reset
                <v-icon dark right>mdi-refresh</v-icon></v-btn>
              <v-btn color="primary" dark class="mb-2" @click="doSelect('', 'tranType')">
                Select
                <v-icon right>mdi-check</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { helpListMixin } from '@/mixins/common/helpListMixin'
import MessageMixin from '@/mixins/message'
import { tranTypeList1, tranTypeList2, tranTypeList3, tranTypeList4 } from '../index'

export default {
  props: {
    'transactionId': String,
    'menu': Object
  },
  data() {
    return {
      headers: [
        { text: 'Transaction Type', value: 'code' },
        { text: 'Description', value: 'value' }
      ],
      items: [],
      allTransList: [],
      acctTransList: [],
      uwTransList: [],
      claimTransList: [],
      pagination: {
        sortBy: [],
        sortDesc: [],
        page: 1,
        itemsPerPage: 5
      }
    }
  },
  created() {
    this.allTransList = tranTypeList1
    this.acctTransList = tranTypeList2
    this.uwTransList = tranTypeList3
    this.claimTransList = tranTypeList4
    this.doInit()
  },
  watch: {
    'transactionId': function(value) {
      this.doInit()
    }
  },
  methods: {
    doInit() {
      this.items = []
      if (this.transactionId === 'AL') {
        // For All Transactions
        const data = this.allTransList
        if (data) {
          data.filter((list) => {
            this.items.push({ key: list.code, code: list.code, value: list.value })
          })
        }
      } else if (this.transactionId === 'AT') {
        // For Account Transactions
        const data = this.acctTransList
        if (data) {
          data.filter((list) => {
            this.items.push({ key: list.code, code: list.code, value: list.value })
          })
        }
      } else if (this.transactionId === 'UT') {
        // For Underwriting Transactions
        const data = this.uwTransList
        if (data) {
          data.filter((list) => {
            this.items.push({ key: list.code, code: list.code, value: list.value })
          })
        }
      } else if (this.transactionId === 'CT') {
        // For Claims Transactions
        const data = this.claimTransList
        if (data) {
          data.filter((list) => {
            this.items.push({ key: list.code, code: list.code, value: list.value })
          })
        }
      } else {
        this.items = []
      }
      if (this.checkedItems.toString() === 'All') {
        this.doReset()
        this.toggleAll()
      } else {
        this.toggleSelected()
      }
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin,
    helpListMixin
  ]
}
</script>

<style>
</style>
